import React from 'react';
import { AuthProvider } from './features/AuthContext';
import RoutesComponent from './routes/routes';

function App() {
    return (
        <AuthProvider>
            <RoutesComponent />
        </AuthProvider>
    );
}

export default App;